import usePrivateAxios from "@/common/api/usePrivateAxios";

import { useMutation } from "@tanstack/react-query";
import type { LeadsFunnelUpdateContactResendEmailValidationSchema } from "../schemas/leadFunnelUpdateResendEmail.schema";

interface UseUpdateLeadContactResendEmail {
  contactId?: string,
  onSuccess?: () => void,
  onError?: (error: any) => void
}

const useUpdateLeadContactResendEmail = ({ contactId, onSuccess, onError }: UseUpdateLeadContactResendEmail) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['updateContact'],
    mutationFn: async (data: LeadsFunnelUpdateContactResendEmailValidationSchema) => {

      await privateAxios.put(`/funnel/contacts/${contactId}/resend_email`, {
        funnel_contact: {
          email: data.funnel_contact.email
        }
      })
    },
    onSuccess,
    onError,
  });
}

export default useUpdateLeadContactResendEmail;